import { ListItemBox } from "lib/@components/ListItemBox"
import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function RemoteAddition() {
    return (
        <ListItemBox sx={{ lineHeight: 0 }} spacing={1} direction="row" alignItems="center">
            <Box sx={{ color: "info.main" }}>
                <Iconify icon="mdi:add" Box />
            </Box>
            <Typography sx={{ color: "text.secondary" }} variant="caption">
                Only changed in the comparison schedule
            </Typography>
        </ListItemBox>
    )
}
